import { defineComponent as _defineComponent } from 'vue'
import {computed, onMounted, ref} from 'vue';
import {isMobile} from "./footerState";
import {type zohoNavItem,  getZohoNavLinks} from './functions';

type tabs = typeof tabsOptions[number]

export default /*#__PURE__*/_defineComponent({
  __name: 'global-footer',
  setup(__props, { expose: __expose }) {
  __expose();

const tabsOptions = ['insideHXP', 'getAnswers', 'contactUs'];
const tabsNameMap: {[key: tabs]: string} = {
	'insideHXP': 'Inside HXP',
	'getAnswers': 'Get Answers',
	'contactUs': 'Contact Us'
};

const zohoLinks = ref<zohoNavItem[]>([]);
onMounted(async () => {
	zohoLinks.value = (await getZohoNavLinks()).filter((link) => link.region === 'footer');
    console.log("Links", zohoLinks.value);
});

const linksBySections = computed(() => {
	const sectionedLinks: {[section: string]:  zohoNavItem[]} = {};
	zohoLinks.value.forEach((link) => {
		if(!sectionedLinks?.[link.section]) sectionedLinks[link.section] = [];

		sectionedLinks[link.section].push(link);
	});

	Object.keys(sectionedLinks).forEach((section) =>  {
		sectionedLinks[section].sort((a, b) => (a?.order || 0) - (b.order || 0));
	});

	return sectionedLinks;
});


function openHXPWebsite(){
	window.open('https://www.humanitarianxp.org/');
}



const __returned__ = { tabsOptions, tabsNameMap, zohoLinks, linksBySections, openHXPWebsite, computed, onMounted, ref, get isMobile() { return isMobile }, get getZohoNavLinks() { return getZohoNavLinks } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})